<template>
	<div v-if="user && user.username && user.username.role == 2 && user.username.admin_name" class="w-100 d-flex align-items-center px-3 mb-3 support">
		<div v-if="user.username.admin_name" class="d-flex align-items-center ml-3">
			<span class="ml-1 black">نام پشتیبان شما:</span>
			<span class="dark">{{ user.username.admin_name ? user.username.admin_name : '-' }}</span>
		</div>
		<div v-if="user.username.admins_tel" class="d-flex align-items-center ml-3">
			<span class="ml-1 black">شماره داخلی:</span>
			<span class="dark">{{ user.username.admins_tel ? user.username.admins_tel : '-' }}</span>
		</div>
		<div v-if="user.username.admins_phone" class="d-flex align-items-center ml-3">
			<span class="ml-1 black">شماره تلفن همراه:</span>
			<span class="dark">{{ user.username.admins_phone ? user.username.admins_phone : '-' }}</span>
		</div>
	</div>
</template>

	<script>
		export default {
			name: 'support',
			data(){
				return {
					user: [],
				}
			},
			components: {},
			props: {
  			
			},
			mounted(){
				this.user = this.$localStorage.get("user");
				if (this.user.username.role==2) {
					this.teachers_count();
				}
			},
			methods:{
				
			}
		}
	</script>
<style>
.support {
	height: 72px;
	background-color: #fff;
	border-radius: 20px;
	box-shadow: 0px 4px 4px 0px #00000040;
}
.black {
	font-size: 14px;
	color: #000;
	font-family: 'IRANSans';
}
.dark {
	font-size: 13px;
	color: #676767;
	font-family: 'IRANSans';
}
</style>
